<template>
	<div class="myhfmtk" @mousewheel.prevent>
		<div class="myhfmtk-div1"></div>
		<div class="myhfmtk-div">
			<div class="myhfmtk-div-top">
				<p class="myhfmtk-div-top-p1">回复:</p>
				<p class="myhfmtk-div-top-p2">{{replycomment}}</p>
			</div>
			<div class="myhfmtk-div-body">
				<textarea
					name
					id
					cols="30"
					rows="10"
					placeholder="追加回复"
					class="myhfmtk-div-body-txt"
					v-model="notedata"
				></textarea>
				<div class="myhfmtk-div-body-div">
					<button type="button" class="myhfmtk-div-body-div-btn" @click="close()">取消</button>
					<button type="button" class="myhfmtk-div-body-div-btn1" @click="publish()">发布</button>
				</div>
			</div>
			<div class="myhfmtk-div-con" v-if="tips==='1'">
				<p class="myhfmtk-div-con-p">评论不足5个字符</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "App",
		components: {},
		props: ["id", "replycomment"],
		data() {
			return {
				dialogTableVisible: false,
				centerDialogVisible: false,
				night: "0",
				djxs: "1",
				notedata: "",
				tips: "",
				commentdata: "",
				tomycomment: ""
			};
		},
		methods: {
			publish() {
				if (this.notedata.length < 5) {
					this.tips = "1";
					setTimeout(res => {
						this.tips = "0";
					}, 2000);
				} else {
					this.$http
						.post("comment/set", {
							id: this.id,
							content: this.notedata,
							token: this.$cookies.get("token")
						})
						.then(res => {
							this.close();
						});
				}
			},
			close() {
				this.$emit("func", this.dialogTableVisible);
			}
		},
		mounted() {}
	};
</script>

<style>
	.myhfmtk-div-con-p {
		font-size: 14px;
	}

	.myhfmtk-div-con {
		width: 140px;
		height: 70px;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(204, 204, 204, 1);
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 100px;
		left: 210px;
	}

	.myhfmtk-div-body-div-btn {
		width: 70px;
		height: 36px;
		background: rgba(204, 204, 204, 1);
		border-radius: 4px;
		border: 0;
		font-size: 14px;
		color: #ffffff;
		margin-right: 30px;
	}

	.myhfmtk-div-body-div-btn1 {
		width: 70px;
		height: 36px;
		background-color: #28a3b1;
		border-radius: 4px;
		border: 0;
		font-size: 14px;
		color: #fff;
		margin-right: 30px;
	}

	.myhfmtk-div-body-div {
		display: flex;
		justify-content: flex-end;
		margin-top: 30px;
	}

	.myhfmtk-div-body-txt {
		width: 520px;
		height: 270px;
		resize: none;
		border: 0;
		border-bottom: 1px solid #e6e6e6 !important;
		outline: none;
	}

	.myhfmtk-div-top-p1 {
		font-size: 16px;
		color: #ffffff;
	}

	.myhfmtk-div-top-p2 {
		font-size: 14px;
		color: #ffffff;
		margin-top: 16px;
		padding-left: 7px;
		box-sizing: border-box;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.myhfmtk-div-body {
		width: 560px;
		height: 387px;
		background: rgba(255, 255, 255, 1);
		border-radius: 0px 0px 12px 12px;
		padding: 20px;
		box-sizing: border-box;
	}

	.myhfmtk-div-top {
		width: 560px;
		height: 133px;
		background: rgba(40, 163, 177, 1);
		border-radius: 12px 12px 0px 0px;
		padding: 16px 17px;
		box-sizing: border-box;
	}

	.myhfmtk {
		width: 100%;
		height: 100%;
		position: fixed;
		display: flex;
		justify-content: center;
		top: 0;
		left: 0;
		align-items: center;
		z-index: 10000;
	}

	.myhfmtk-div1 {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 1);
		opacity: 0.3;
		position: absolute;
	}

	.myhfmtk-div {
		width: 560px;
		height: 500px;
		z-index: 10000;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/publicmyhfmtk.vue